import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { z } from "zod";

export const useErfinaProductFormSchema = () => {
  const { t } = useTranslation("product");

  const schema = useMemo(
    () =>
      z.object({
        lampu_product_id: z.string().optional(),
        product_family: z.string().optional(),
        product_code_debit: z
          .string()
          .max(
            3,
            t(
              "integrationProductListPage.erfinaModal.validations.productCodeDebitMaxLength"
            )
          )
          .optional(),
        coa_debit: z
          .string()
          .max(
            8,
            t(
              "integrationProductListPage.erfinaModal.validations.coaDebitMaxLength"
            )
          )
          .optional(),
        product_code_credit: z
          .string()
          .max(
            3,
            t(
              "integrationProductListPage.erfinaModal.validations.productCodeCreditMaxLength"
            )
          )
          .optional(),
        coa_credit: z
          .string()
          .max(
            8,
            t(
              "integrationProductListPage.erfinaModal.validations.coaCreditMaxLength"
            )
          )
          .optional()
      }),
    [t]
  );

  return schema;
};

export type ErfinaProductFormSchema = z.infer<
  ReturnType<typeof useErfinaProductFormSchema>
>;
